import { render, staticRenderFns } from "./StickyToasts.vue?vue&type=template&id=3990cc25"
import script from "./StickyToasts.vue?vue&type=script&lang=js"
export * from "./StickyToasts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3990cc25')) {
      api.createRecord('3990cc25', component.options)
    } else {
      api.reload('3990cc25', component.options)
    }
    module.hot.accept("./StickyToasts.vue?vue&type=template&id=3990cc25", function () {
      api.rerender('3990cc25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StickyToasts.vue"
export default component.exports